import { kuxLogger } from './config';

export interface MigrationRequestParams {
  stbMigrationUrl?: string;
  mac?: string;
  wrongAppAnalyticsUrl?: string;
  subscriptionCode?: string;
  brand?: string;
  family?: string;
  isSTBMigrationOperation?: boolean;
  firstSTBApplySettings?: boolean;
}
export enum MigrateOperation {
  SETTINGS_APPLIED = 'SETTINGS_APPLIED',
  HOMEPAGE = 'HOMEPAGE',
  UNSUCCESSFULL_SILENT_LOGIN = 'UNSUCCESSFULL_SILENT_LOGIN',
  ACCESS_BLOCKED = 'ACCESS_BLOCKED',
}

export const EventNumber: { [val in MigrateOperation]: string } = {
  [MigrateOperation.SETTINGS_APPLIED]: '5',
  [MigrateOperation.HOMEPAGE]: '7',
  [MigrateOperation.UNSUCCESSFULL_SILENT_LOGIN]: '6',
  [MigrateOperation.ACCESS_BLOCKED]: '0',
};

export const RequestMapping: {
  [val in MigrateOperation]: {
    isValidMethod: (params: MigrationRequestParams) => boolean;
    getEndpoint: (params: MigrationRequestParams) => string;
    getData: (params: MigrationRequestParams) => string;
  };
} = {
  [MigrateOperation.SETTINGS_APPLIED]: {
    isValidMethod: ({ isSTBMigrationOperation, stbMigrationUrl, mac }) =>
      !!isSTBMigrationOperation && !!stbMigrationUrl && !!mac,
    getEndpoint: ({ stbMigrationUrl, mac }) => `${stbMigrationUrl}/status/${mac}`,
    getData: () => EventNumber[MigrateOperation.SETTINGS_APPLIED],
  },
  [MigrateOperation.HOMEPAGE]: {
    isValidMethod: ({ isSTBMigrationOperation, firstSTBApplySettings, stbMigrationUrl, mac }) =>
      !!isSTBMigrationOperation && !!stbMigrationUrl && !!mac && !!firstSTBApplySettings,
    getEndpoint: ({ stbMigrationUrl, mac }) => `${stbMigrationUrl}/status/${mac}`,
    getData: () => EventNumber[MigrateOperation.HOMEPAGE],
  },
  [MigrateOperation.UNSUCCESSFULL_SILENT_LOGIN]: {
    isValidMethod: ({ isSTBMigrationOperation, stbMigrationUrl, mac }) =>
      !!isSTBMigrationOperation && !!stbMigrationUrl && !!mac,
    getEndpoint: ({ stbMigrationUrl, mac }) => `${stbMigrationUrl}/status/${mac}`,
    getData: () => EventNumber[MigrateOperation.UNSUCCESSFULL_SILENT_LOGIN],
  },
  [MigrateOperation.ACCESS_BLOCKED]: {
    isValidMethod: ({ wrongAppAnalyticsUrl }) => !!wrongAppAnalyticsUrl,
    getEndpoint: ({ wrongAppAnalyticsUrl, subscriptionCode }) => `${wrongAppAnalyticsUrl}/${subscriptionCode}`,
    getData: ({ brand, family }) =>
      JSON.stringify({
        brand,
        family,
      }),
  },
};

export const sendMigrationEvent = async (eventName: MigrateOperation, data: MigrationRequestParams) => {
  if (!RequestMapping[eventName].isValidMethod(data)) {
    return;
  }
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: RequestMapping[eventName].getData(data),
  };

  try {
    await fetch(RequestMapping[eventName].getEndpoint(data), requestOptions);
    kuxLogger('event sent', RequestMapping[eventName].getEndpoint(data), requestOptions);
  } catch (e) {
    console.log('Unable to send migration event', e);
  }
};
